import React from 'react';
import PropTypes from 'prop-types';

ChargePricingDetailView.propTypes = {
  pricingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function ChargePricingDetailView({ pricingId }) {
  // MARK: ---- PROPERTIES ----

  return <div></div>;
}

export default ChargePricingDetailView;
